import React from 'react';
interface HeaderProps {
  currentTopic: number;
  totalTopics: number;
}
export function Header({
  currentTopic,
  totalTopics
}: HeaderProps) {
  const progress = (currentTopic + 1) / totalTopics * 100;
  return <header className="fixed top-0 left-0 right-0 bg-white z-50 shadow-sm" data-id="element-35">
      <div className="max-w-mobile mx-auto" data-id="element-36">
        <div className="flex items-center justify-between px-6 py-4" data-id="element-37">
          <div className="font-bold text-roche-blue text-lg tracking-tight" data-id="element-38">
            ROCHE
          </div>
          <div className="text-xs text-text-secondary font-medium px-2 py-1 bg-gray-100 rounded" data-id="element-39">
            Ad
          </div>
        </div>

        {/* Progress bar */}
        <div className="h-1 bg-gray-200" data-id="element-40">
          <div className="h-full bg-roche-blue transition-smooth" style={{
          width: `${progress}%`
        }} data-id="element-41" />
        </div>

        {/* Dot pagination */}
        <div className="flex items-center justify-center gap-2 py-3" data-id="element-42">
          {Array.from({
          length: totalTopics
        }).map((_, index) => <div key={index} className={`h-2 w-2 rounded-full transition-smooth ${index === currentTopic ? 'bg-roche-blue w-6' : 'bg-gray-300'}`} aria-label={`Topic ${index + 1}${index === currentTopic ? ' (current)' : ''}`} data-id="element-43" />)}
        </div>
      </div>
    </header>;
}